import { useEffect } from "react";
import { useStockControlStore } from "../../hooks/useStockControlStore";
import { useControlStockAlAzar } from "../../helpers/useControlStockALAzar";
import FormularioBase from "./FormularioBase";
import ArticuloInfo from "./ArticuloInfo";

const FormularioAlAzar = ({ mostrarTipoControl = true, tituloAlternativo }) => {
  const { articuloActual } = useStockControlStore();

  const { inicializar, guardarYAvanzar, marcarComoInexistente, noControlar, loading } = useControlStockAlAzar();

  useEffect(() => {
    inicializar();
  }, []);

  const camposPersonalizados = <ArticuloInfo articulo={articuloActual} loading={loading} />;

  return (
    <FormularioBase
      mostrarTipoControl={mostrarTipoControl}
      tituloAlternativo={tituloAlternativo}
      camposPersonalizados={camposPersonalizados}
      onProximo={guardarYAvanzar}
      onInexistente={marcarComoInexistente}
      onNoControlar={noControlar}
      loading={loading}
    />
  );
};

export default FormularioAlAzar;
